import { render, staticRenderFns } from "./FreeProductItem.vue?vue&type=template&id=4f0580bd&scoped=true&"
import script from "./FreeProductItem.vue?vue&type=script&lang=js&"
export * from "./FreeProductItem.vue?vue&type=script&lang=js&"
import style0 from "./FreeProductItem.vue?vue&type=style&index=0&id=4f0580bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0580bd",
  null
  
)

export default component.exports